import {
  JOB_POSTING_STATUS_VALUES,
  jobPostingStatusIsTerminal,
  type JobPostingStatus,
} from '../../../generated/config-enums';

/**
 * The job-posting statuses that END a requisition — DERIVED from each entry's
 * `is_terminal` flag in `shared/config/recruiting_job_posting_status.config.json`,
 * which is the same partition
 * `modules/recruiting/services/deletion_dependency_provider.py` reads through
 * `JOB_POSTING_STATUS_TERMINAL_SET`. Two surfaces used to spell `['closed',
 * 'filled']` by hand instead (the job picker's default exclusion and the
 * interview form's "apply to a new job" list), so a status added to the
 * lifecycle would have kept offering a requisition nobody is sourcing for.
 */
export const TERMINAL_JOB_STATUSES: readonly JobPostingStatus[] = JOB_POSTING_STATUS_VALUES.filter(
  (status) => jobPostingStatusIsTerminal[status]
);

/**
 * Whether a job posting's lifecycle has ended. A NULL or unrecognized status
 * reads as LIVE, matching the backend guard: the column is nullable with a
 * `draft` default, so an unknown must not quietly wave a requisition out of a
 * picker.
 */
export function isTerminalJobStatus(status: string | null | undefined): boolean {
  return status != null && jobPostingStatusIsTerminal[status as JobPostingStatus] === true;
}
